export const createRoute = (route) => ({
    accCode: "",
    action: "access",
    redirectTo: "/403",
    parentCode: "",
    ...route,
});

export const addNonePermissionRoute = (routes = []) => routes.map((route) => ({
    ...route, handle: { ...route.handle, accCode: 'none' }
}));

export const addHandleRoute = (routes = []) => routes.map((route) => ({
    ...route,
    handle: {
        ...route.handle,
        accCode: route.accCode ?? route.handle?.accCode,
        action: route.action ?? route.handle?.action,
        ...(route.redirectTo && { redirectTo: route.redirectTo, }),
        ...(route.parentCode && { parentCode: route.parentCode, }),
    },
    ...(route.children && {
        children: addHandleRoute(route.children),
    }),
}));